import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Trophy, Video, DollarSign, ArrowUpRight } from 'lucide-react';
export function Features() {
  return <section className="bg-neutral-900 py-24 relative" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-8" data-id="element-33">
          <div data-id="element-34">
            <span className="text-red-600 font-bold tracking-widest uppercase text-sm" data-id="element-35">
              Platform Capabilities
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase italic tracking-tighter mt-2" data-id="element-36">
              Built for <br data-id="element-37" />
              Speed
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md text-lg" data-id="element-38">
            Our infrastructure is designed for zero-latency action. Don't blink.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-39">
          {/* Feature 1 - Large */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="col-span-1 md:col-span-2 bg-neutral-950 border border-neutral-800 p-8 md:p-12 relative overflow-hidden group" data-id="element-40">
            <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 group-hover:bg-red-600/20 transition-colors" data-id="element-41" />
            <div className="relative z-10 flex flex-col md:flex-row gap-8 items-start md:items-center" data-id="element-42">
              <div className="p-4 bg-neutral-900 rounded-lg border border-neutral-800" data-id="element-43">
                <Video className="w-10 h-10 text-red-600" data-id="element-44" />
              </div>
              <div className="flex-1" data-id="element-45">
                <h3 className="text-2xl font-black text-white uppercase mb-2" data-id="element-46">
                  Zero-Latency Streaming
                </h3>
                <p className="text-neutral-400" data-id="element-47">
                  Experience the action as it happens. Our proprietary
                  compression algorithm delivers 4K streams with sub-second
                  delay, perfect for high-speed racing and twitch-reaction
                  gameplay.
                </p>
              </div>
              <ArrowUpRight className="w-8 h-8 text-neutral-600 group-hover:text-red-600 transition-colors" data-id="element-48" />
            </div>
          </motion.div>

          {/* Feature 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-neutral-950 border border-neutral-800 p-8 relative overflow-hidden group hover:border-red-900/50 transition-colors" data-id="element-49">
            <Trophy className="w-8 h-8 text-red-600 mb-6" data-id="element-50" />
            <h3 className="text-xl font-black text-white uppercase mb-3" data-id="element-51">
              Real Stakes Tournaments
            </h3>
            <p className="text-neutral-400 text-sm" data-id="element-52">
              Automated bracket systems with instant payout integration. Compete
              for real cash prizes in daily and weekly cups.
            </p>
          </motion.div>

          {/* Feature 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-neutral-950 border border-neutral-800 p-8 relative overflow-hidden group hover:border-red-900/50 transition-colors" data-id="element-53">
            <DollarSign className="w-8 h-8 text-red-600 mb-6" data-id="element-54" />
            <h3 className="text-xl font-black text-white uppercase mb-3" data-id="element-55">
              Creator Monetization
            </h3>
            <p className="text-neutral-400 text-sm" data-id="element-56">
              Keep 95% of your earnings. Subscriptions, donations, and
              sponsorship marketplace built directly into your dashboard.
            </p>
          </motion.div>

          {/* Feature 4 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="col-span-1 md:col-span-2 bg-neutral-950 border border-neutral-800 p-8 relative overflow-hidden group hover:border-red-900/50 transition-colors flex flex-col md:flex-row items-center gap-6" data-id="element-57">
            <div className="flex-1" data-id="element-58">
              <div className="flex items-center gap-4 mb-4" data-id="element-59">
                <Globe className="w-6 h-6 text-red-600" data-id="element-60" />
                <h3 className="text-xl font-black text-white uppercase" data-id="element-61">
                  Global Hub
                </h3>
              </div>
              <p className="text-neutral-400 text-sm" data-id="element-62">
                Connect with servers in Frankfurt, Singapore, New York, and São
                Paulo. One world, one speed.
              </p>
            </div>
            <div className="w-full md:w-1/3 h-2 bg-neutral-900 rounded-full overflow-hidden" data-id="element-63">
              <div className="h-full bg-red-600 w-3/4 animate-pulse" data-id="element-64" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}